import React from 'react';
import { Helmet } from 'react-helmet';

// Global Components
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import RoleGate from 'components/RoleGate';
import RoleButton from 'components/RoleButton';
import SaveMessage from 'components/SaveMessage';

import { ADMIN } from 'components/RoleGate/constants';
import { VARIETY_CREATE_NAMESPACE } from 'services/varieties/constants';
import { CREATE_MODAL_QUERY_STRING_PARAM } from 'components/VirtualizedTable/constants';
import HarvestSchemaExistsGate from 'components/HarvestSchemaExistsGate';

// Local Components
import VarietiesVirtualizedTable from './components/VarietiesVirtualizedTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

export class Varieties extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <HarvestSchemaExistsGate>
                <RoleGate requiredRoles={[ADMIN]}>
                    <ErrorBoundary
                        namespace="Varieties"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Helmet>
                            <title>Varieties - {REACT_APP_PROJECT_NAME}</title>
                        </Helmet>
                        <PageTitleAndFilters
                            title="Varieties"
                            searchInputPlaceholder="Search"
                            hideFilters
                            MessageComponent={
                                <SaveMessage
                                    namespace={[VARIETY_CREATE_NAMESPACE]}
                                />
                            }
                            FirstActionButton={
                                <RoleButton
                                    requiredRoles={[ADMIN]}
                                    params={{
                                        [CREATE_MODAL_QUERY_STRING_PARAM]: true
                                    }}
                                    ignoreSeason
                                    buttonProps={{
                                        secondary: true,
                                        style: {
                                            marginRight: 0,
                                            marginLeft: 8
                                        }
                                    }}
                                >
                                    Create New
                                </RoleButton>
                            }
                        />
                        <PageTitleAndFiltersPusher>
                            <VarietiesVirtualizedTable tableId="varieties" />
                        </PageTitleAndFiltersPusher>
                    </ErrorBoundary>
                </RoleGate>
            </HarvestSchemaExistsGate>
        );
    }
}

export default Varieties;
